{
  "levels": [
    {
      "id": "authorized-prover",
      "name": "Authorized Prover",
      "brief": "You hold a PRIVATE authority DAG. The auditor issues compliance challenges. Build an accepting transcript for each — commit, then respond — without ever disclosing an edge.",
      "compliant": true,
      "witnessSummary": "Private authority DAG with a reachability path for every challenge.",
      "challenges": [
        {
          "id": "ch-permit-billing",
          "theorem": "PERMIT",
          "statement": "Subject S₇ may reach authority A-BILLING under PERMIT.",
          "subject": "S₇",
          "authority": "A-BILLING",
          "witnessHeld": true,
          "auditorNote": "Prove the action is authorized without revealing which subjects hold which authorities."
        },
        {
          "id": "ch-permit-deploy",
          "theorem": "PERMIT",
          "statement": "Subject S₃ may reach authority A-DEPLOY under PERMIT.",
          "subject": "S₃",
          "authority": "A-DEPLOY",
          "witnessHeld": true,
          "auditorNote": "Prove deployment authority without disclosing the authority hierarchy."
        },
        {
          "id": "ch-origin-export",
          "theorem": "DATA.ORIGIN",
          "statement": "Datum d-EXPORT has certified provenance from origin o-INGEST.",
          "subject": "d-EXPORT",
          "authority": "o-INGEST",
          "witnessHeld": true,
          "auditorNote": "Certify end-to-end provenance without revealing the intermediate processing chain."
        }
      ]
    },
    {
      "id": "non-compliant-prover",
      "name": "Non-Compliant Prover",
      "brief": "The auditor adds a challenge for which NO reachability path exists in your DAG. There is no forge-acceptance move — the accepting response is structurally absent, not denied. Soundness (ZKP-3) holds by construction.",
      "compliant": false,
      "witnessSummary": "Private authority DAG missing a path for one challenge — soundness makes acceptance unconstructable.",
      "challenges": [
        {
          "id": "ch-permit-payroll",
          "theorem": "PERMIT",
          "statement": "Subject S₂ may reach authority A-PAYROLL under PERMIT.",
          "subject": "S₂",
          "authority": "A-PAYROLL",
          "witnessHeld": true,
          "auditorNote": "A held witness: an accepting transcript is constructable."
        },
        {
          "id": "ch-permit-root",
          "theorem": "PERMIT",
          "statement": "Subject S₂ may reach authority A-ROOT under PERMIT.",
          "subject": "S₂",
          "authority": "A-ROOT",
          "witnessHeld": false,
          "auditorNote": "No DAG path exists from S₂ to A-ROOT. By ZKP-3 soundness, no accepting transcript is constructable — the move generator yields nothing to commit, and forging acceptance is not in the move set."
        },
        {
          "id": "ch-precommit-slot",
          "theorem": "PRECOMMIT",
          "statement": "Action a-RELEASE was committed before authorization at grade t₄.",
          "subject": "a-RELEASE",
          "authority": "t₄",
          "witnessHeld": true,
          "auditorNote": "A held graded-monad token: an accepting transcript is constructable."
        }
      ]
    }
  ]
}
